import { Button, Card, CardContent, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, InputAdornment, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { apiConstants, get, post } from "../../common/constants";
import { formatCurrency } from "../../helpers/UtilityHelper";
import { FormProvider, RHFRadioGroup, RHFSearchableSelectField, RHFTextField } from "../../common/hook-form";
import { useGetAllActiveMerchantsIdAndNameCachedQuery } from "../../redux/commonApiCalls";
import { useSnackbar } from "notistack";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import _ from "lodash";
import PageTitle from "../../components/PageTitle";
import { LoadingButton } from "@mui/lab";


function UpdateOffine() {
    const [merchant, setMerchant] = useState(null)
    const [remarks, setRemarks] = useState(null);
    const [amount, setAmount] = useState(null)
    const [refer, setRefer] = useState(null)
    const { enqueueSnackbar } = useSnackbar()
    const { data: merchants = [] } = useGetAllActiveMerchantsIdAndNameCachedQuery();
    const [open, setOpen] = useState(false);
    const [type, setType] = useState()
    const [loading, setLoading] = useState(false)

    const methods = useForm({
        defaultValues: {
            merchant: "",
            transactionType: "CREDIT",
            transactionAmount: "",
            referenceId: "",
            remarks: "",
        }
    });

    const {
        handleSubmit,
        reset,
        getValues,
        watch
    } = methods;

    // the wallet this credit/debit will actually land on — shown before the admin submits
    const selectedMerchantId = watch('merchant');
    const [activeWallet, setActiveWallet] = useState(null);
    useEffect(() => {
        setActiveWallet(null);
        if (selectedMerchantId) {
            get(`${apiConstants.WALLET}?merchantId=${selectedMerchantId}`)
                .then((res) => {
                    const users = res.data?.responseObj || [];
                    setActiveWallet(users.find((w) => w.isActive === true) || null);
                })
                .catch((err) => console.log(err));
        }
    }, [selectedMerchantId]);

    const onSubmit = () => {
        handleClickOpen()
    }
    const handleoffline = () => {
        setLoading(true)
        post(apiConstants.UPDATE_OFFLINE, {
            "merchantOId": merchant,
            "amount": amount,
            "currency": "INR",
            "description": remarks,
            "reference_id": refer,
            "transaction_type": type
        }).then((res) => {
            if (res.status === 200) {
                enqueueSnackbar(`Payment is successfully Updated`, { variant: 'success' })
                setLoading(false)
                reset()
            }
        }).catch((err) => {
            enqueueSnackbar(`Please fill the mandatory fields`, { variant: 'error' });
            setLoading(false);
        })

    }


    const handleClickOpen = () => {
        const { merchant, transactionType, transactionAmount, referenceId, remarks } = getValues();
        setMerchant(merchant)
        setType(transactionType)
        setAmount(transactionAmount)
        setRefer(referenceId)
        setRemarks(remarks)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const handleAgree = () => {
        handleoffline();
        handleClose();
        setMerchant(null)
        setType(null)
        setAmount(null)
        setRefer(null)
        setRemarks(null)
    }


    return (
        <>
            <PageTitle>Offline Payment Update</PageTitle>
            <Card>
                {/* <CardHeader title="Update Offline Balance" /> */}
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={6} md={3}><Typography variant='subtitle1' color={"black"} sx={{ paddingTop: 2 }}>Merchant Name
                                <Typography component='span' color={"red"}>*</Typography>
                            </Typography>
                            </Grid>
                            <Grid item xs={6} md={3}><Typography variant='subtitle2' color={"black"}>
                                <RHFSearchableSelectField
                                    fullWidth
                                    label="Select Merchant"
                                    options={_.orderBy(merchants, 'name').map((val) => ({
                                        value: val.id,
                                        label: val.name
                                    }))}
                                    name="merchant"
                                    required
                                />
                            </Typography></Grid>
                        </Grid>
                        {selectedMerchantId && activeWallet && (
                            <Grid container spacing={1} sx={{ paddingTop: 1 }}>
                                <Grid item xs={6} md={3}><Typography variant='subtitle1' color={"black"} sx={{ paddingTop: 1 }}>Target Wallet</Typography></Grid>
                                <Grid item xs={6} md={4}>
                                    <Typography variant='subtitle2' sx={{ pt: 1 }}>
                                        <Chip size="small" variant="outlined" label={`${activeWallet.walletType} · ACTIVE`}
                                            color={activeWallet.walletType === 'Prepaid' ? 'primary' : 'secondary'} />
                                        {' '}
                                        {activeWallet.walletType === 'Prepaid'
                                            ? `Current balance: ${formatCurrency(activeWallet.walletBalance || 0)}`
                                            : `Current due: ${formatCurrency(activeWallet.dueAmount || 0)} / limit ${formatCurrency(activeWallet.creditLimit || 0)}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                        <Grid container spacing={1} sx={{ paddingTop: 2 }}>
                            <Grid item xs={6} md={3}><Typography variant='subtitle1' color={"black"} sx={{ paddingTop: 2 }}>Transaction Type
                                <Typography component='span' color={"red"}>*</Typography>
                            </Typography>
                            </Grid>
                            <Grid item xs={6} md={3}><Typography variant='subtitle1' color={"black"}>
                                <RHFRadioGroup
                                    name="transactionType"
                                    options={[
                                        { label: 'CREDIT', value: 'CREDIT' },
                                        { label: 'DEBIT', value: 'DEBIT' },
                                    ]}
                                    required
                                />
                            </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} sx={{ paddingTop: 3 }}>
                            <Grid item xs={6} md={3}><Typography variant='subtitle1' color={"black"} sx={{ paddingTop: 2 }}>Update offline balance
                                <Typography component='span' color={"red"}>*</Typography>
                            </Typography>
                            </Grid>
                            <Grid item xs={6} md={3}><Typography variant='subtitle2' color={"black"} >
                                <RHFTextField
                                    label="Update offline balance"
                                    name="transactionAmount"
                                    fullWidth
                                    required
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start"><CurrencyRupeeIcon /></InputAdornment>,
                                    }}
                                />
                            </Typography>
                            </Grid>
                        </Grid >
                        <Grid container spacing={1} sx={{ paddingTop: 2 }}>
                            <Grid item xs={6} md={3}><Typography variant='subtitle1' color={"black"} sx={{ paddingTop: 2 }}>Reference Id
                                <Typography component='span' color={"red"}>*</Typography>
                            </Typography>
                            </Grid>
                            <Grid item xs={6} md={3} ><Typography variant='subtitle2' color={"black"}>
                                <RHFTextField
                                    label="Reference Id"
                                    name="referenceId"
                                    fullWidth
                                    required
                                />
                            </Typography>
                            </Grid>
                        </Grid >
                        <Grid container spacing={1} sx={{ paddingTop: 2 }}>
                            <Grid item xs={6} md={3}><Typography variant='subtitle1' color={"black"} sx={{ paddingTop: 1 }}>Remarks
                                <Typography component='span' color={"red"}>*</Typography>
                            </Typography>
                            </Grid>
                            <Grid item xs={6} md={3} ><Typography variant='subtitle2' color={"black"} >
                                <RHFTextField
                                    label="Remarks"
                                    name="remarks"
                                    fullWidth
                                    required
                                    multiline
                                    rows={4}
                                />
                            </Typography></Grid>
                            <Grid item xs={12} md={12} sx={{ mt: 2 }}>
                                <LoadingButton loading={loading} variant="contained" size="medium" type="submit" >Update</LoadingButton>
                            </Grid>
                        </Grid >
                    </FormProvider>
                </CardContent>
            </Card>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {`Confirm Offline ${type || 'Transaction'}`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ₹{amount} will be {type === 'CREDIT' ? 'credited to' : 'debited from'} the merchant's{' '}
                        {activeWallet ? `${activeWallet.walletType} wallet` : 'active wallet'}
                        {activeWallet?.walletType === 'Prepaid' && ` (current balance ${formatCurrency(activeWallet.walletBalance || 0)})`}
                        {activeWallet?.walletType === 'Postpaid' && ` (current due ${formatCurrency(activeWallet.dueAmount || 0)})`}
                        {' '}against Reference Id {refer}. Are you sure you want to proceed?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Disagree</Button>
                    <Button onClick={handleAgree}>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default UpdateOffine;